// address
export const SHIP_TO_THIS_ADDRESS = 'ship-to-this-address';
export const ADD_SHIP_ADDRESS = 'add-ship-address';
export const DELETE_SHIP_ADDRESS = 'delete-ship-address';
export const EDIT_SHIP_ADDRESS = 'edit-ship-address';

// billing address
export const USE_THIS_BILLING_ADDRESS = 'use-this-billing-address';
export const EDIT_BILL_ADDRESS = 'edit-bill-address';
export const ADD_BILL_ADDRESS = 'add-bill-address';

// payment
export const ADD_NEW_PAYMENT = 'add-new-payment';
export const USE_THIS_PAYMENT_DESKTOP = 'use-this-payment-desktop';
export const USE_THIS_PAYMENT = 'use-this-payment';
export const CONFIRM_CREDIT_CARD = 'confirm-credit-card';
export const UPDATE_PAYMENT_EXP = 'update-payment-exp';

// review
export const UPDATE_ITEM_QUANTITY = 'update-item-quantity';
